import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/contexts/RoleContext';
import { canAccessRoute } from '@/router/routePermissions';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = usePermissions();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (isLoading) return <div role="status" className="p-6">{t('common.loading')}</div>;
  if (!canAccessRoute(user, pathname)) return <main className="mx-auto max-w-xl p-6">
    <h1 className="text-2xl font-semibold">403</h1>
    <p className="my-4">{t('auth.forbidden', 'Bạn không có quyền truy cập trang này.')}</p>
    <Link to="/profile" className="text-primary-700 underline">{t('auth.backToProfile', 'Tài khoản của tôi')}</Link>
  </main>;
  return <>{children}</>;
}

export default ProtectedRoute;
